import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

const useDefinitiveResolutionService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingGetDefinitiveResolution, setFetchingGetDefinitiveResolution] = useState(false);
    const [fetchingCreateDefinitiveResolution, setFetchingCreateDefinitiveResolution] = useState(false);
    const [fetchingUpdateDefinitiveResolution, setFetchingUpdateDefinitiveResolution] = useState(false);
    const [fetchingSendPaymentEmail, setFetchingSendPaymentEmail] = useState(false);
    const [fetchingCreateFlowPayment, setFetchingCreateFlowPayment] = useState(false);
    const [fetchingGetSubstantiveExaminationId, setFetchingGetSubstantiveExaminationId] = useState(false);
    const [fetchingMarkAsPaid, setFetchingMarkAsPaid] = useState(false);

    const getSubstantiveExaminationId = (brandRegistrationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/${brandRegistrationId}/substantive-examination-id`),
            setFetching: setFetchingGetSubstantiveExaminationId
        });
    };

    const getDefinitiveResolution = (substantiveExaminationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/definitive-resolution/${substantiveExaminationId}`),
            setFetching: setFetchingGetDefinitiveResolution
        });
    };

    const createDefinitiveResolution = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('brand-registrations/definitive-resolution/create'),
            body: data,
            setFetching: setFetchingCreateDefinitiveResolution
        });
    };

    const updateDefinitiveResolution = (resolutionId: number, data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`brand-registrations/definitive-resolution/${resolutionId}/update`),
            body: data,
            requestType: 'multipart',
            setFetching: setFetchingUpdateDefinitiveResolution
        });
    };

    const sendDefinitiveResolutionPaymentEmail = (resolutionId: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`brand-registrations/definitive-resolution/${resolutionId}/send-payment-email`),
            setFetching: setFetchingSendPaymentEmail
        });
    };

    const createFlowPaymentForDefinitiveResolution = (resolutionId: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`brand-registrations/definitive-resolution/${resolutionId}/create-flow-payment`),
            setFetching: setFetchingCreateFlowPayment
        });
    };

    const markAsPaidDefinitiveResolution = (resolutionId: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('brand-registrations/definitive-resolution/mark-as-paid'),
            body: { resolution_id: resolutionId },
            setFetching: setFetchingMarkAsPaid
        });
    };

    return {
        getSubstantiveExaminationId,
        getDefinitiveResolution,
        createDefinitiveResolution,
        updateDefinitiveResolution,
        sendDefinitiveResolutionPaymentEmail,
        createFlowPaymentForDefinitiveResolution,
        markAsPaidDefinitiveResolution,
        fetchingGetSubstantiveExaminationId,
        fetchingGetDefinitiveResolution,
        fetchingCreateDefinitiveResolution,
        fetchingUpdateDefinitiveResolution,
        fetchingSendPaymentEmail,
        fetchingCreateFlowPayment,
        fetchingMarkAsPaid
    };
};

export default useDefinitiveResolutionService;

